module.exports = __webpack_public_path__ + "4ce9cd0a65c59cd346d9c7fa61376c45.png";